import axios from 'axios';
import { createContext, useEffect, useReducer } from 'react';
import { authReducer } from '../reducers/authReducer';
import {
  apiUrl,
  LOAD_SUCCESS,
  LOCAL_STORAGE_TOKEN_NAME,
} from '../utils/constants';
import setAuthToken from '../utils/setAuthToken';
import { userIdChannel } from './ConversationContext';

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [authState, dispatch] = useReducer(authReducer, {
    authLoading: true,
    isAuthenticated: false,
    user: null,
  });

  const loadUser = async () => {
    if (localStorage[LOCAL_STORAGE_TOKEN_NAME]) {
      setAuthToken(localStorage[LOCAL_STORAGE_TOKEN_NAME]);

      try {
        const response = await axios.get(`${apiUrl}/auth`);
        if (response?.status === 200) {
          if (
            !response?.data?.data?.isSecondFactorAuthenticated &&
            response?.data?.data?.isTwoFactorEnabled
          ) {
            dispatch({
              type: LOAD_SUCCESS,
              payload: { isAuthenticated: false, user: response?.data?.data },
            });
          } else {
            dispatch({
              type: LOAD_SUCCESS,
              payload: { isAuthenticated: true, user: response?.data?.data },
            });
          }
        }
      } catch (error) {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN_NAME);
        setAuthToken(null);
        dispatch({
          type: LOAD_SUCCESS,
          payload: { isAuthenticated: false, user: null },
        });
        if (error?.response?.data) return error?.response?.data;
        else return { success: false, message: error?.message };
      }
    } else {
      setAuthToken(null);
      dispatch({
        type: LOAD_SUCCESS,
        payload: { isAuthenticated: false, user: null },
      });
    }
  };
  useEffect(() => {
    async function handleLoadUser() {
      await loadUser();
    }
    handleLoadUser();
  }, []);

  const loginUser = async (loginForm) => {
    try {
      // const response = !isLoginFb
      //   ? !credential
      //     ? await axios.post(`${apiUrl}/auth/login`, loginForm)
      //     : await axios.post(`${apiUrl}/auth/login-google`, credential)
      //   : await axios.post(`${apiUrl}/auth/login-facebook`, credential);
      const response = await axios.post(`${apiUrl}/auth/login`, loginForm);
      if (response?.status === 200) {
        if (!response.data.data.user.isTwoFactorEnabled) {
          localStorage.setItem(
            LOCAL_STORAGE_TOKEN_NAME,
            response?.data?.data?.token
          );
          await loadUser();
        } else {
          setAuthToken(response?.data?.data.token);
          dispatch({
            type: LOAD_SUCCESS,
            payload: {
              isAuthenticated: false,
              user: response?.data?.data.user,
            },
          });
        }
      }

      return response?.data;
    } catch (error) {
      localStorage.removeItem(LOCAL_STORAGE_TOKEN_NAME);
      setAuthToken(null);
      dispatch({
        type: LOAD_SUCCESS,
        payload: { isAuthenticated: false, user: null },
      });
      if (error?.response?.data) return error?.response?.data;
      else return { success: false, message: error?.message };
    }
  };

  const registerUser = async (registerForm) => {
    try {
      const response = await axios.post(
        `${apiUrl}/auth/register`,
        registerForm
      );
      return response;
    } catch (error) {
      if (error?.response?.data) return error?.response?.data;
      else return { success: false, message: error?.message };
    }
  };

  const verifyUser = async (activateForm) => {
    try {
      const response = await axios.put(`${apiUrl}/auth/activate`, activateForm);
      return response;
    } catch (error) {
      if (error?.response?.data) return error?.response?.data;
      else return { success: false, message: error?.message };
    }
  };

  const logoutUser = () => {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN_NAME);
    setAuthToken(null);
    dispatch({
      type: LOAD_SUCCESS,
      payload: { isAuthenticated: false, user: null },
    });
    userIdChannel?.close();
  };

  const sendMailResetPassword = async (email) => {
    try {
      const response = await axios.post(
        `${apiUrl}/auth/send-mail-reset-password`,
        email
      );
      return response;
    } catch (error) {
      if (error?.response?.data) return error?.response?.data;
      else return { success: false, message: error?.message };
    }
  };

  const resetPassword = async (resetPasswordForm) => {
    try {
      const response = await axios.put(
        `${apiUrl}/auth/reset-password`,
        resetPasswordForm
      );
      return response;
    } catch (error) {
      if (error?.response?.data) return error?.response?.data;
      else return { success: false, message: error?.message };
    }
  };

  const authContextData = {
    loadUser,
    loginUser,
    registerUser,
    logoutUser,
    authState,
    verifyUser,
    sendMailResetPassword,
    resetPassword,
    dispatch,
  };

  return (
    <AuthContext.Provider value={authContextData}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
